import React from 'react'
import i18next from 'i18next'
import { Modal, Button, Form } from 'react-bootstrap'
import { Trans } from 'react-i18next'
import hash from 'object-hash'
import ReactQuill from 'react-quill-new'
import imageCompression from 'browser-image-compression'

import 'react-quill-new/dist/quill.snow.css'

import SelectAgentsModal from 'src/components/system_wide/select_agents_modal'

const { t } = i18next

class DocumentForm extends React.Component {
  static defaultProps = {
    users: [],
    roles: [],
    brands: [],
    onSave: () => {},
  }

  state = {
    id: null,
    title: '',
    message: '',
    selected_users: [],
    show: false,
    message_hash: '',
  }
  initialHash = ''

  quillRef = React.createRef()
  selectAgentsModalRef = React.createRef()

  updateHash = () => {
    let { message_hash, show, ...rest } = this.state
    this.setState({ message_hash: hash(rest) })
  }

  show = ({ data = { id: null, title: '', message: '', selected_users: [] } }) => {
    this.initialHash = hash({ ...data })
    this.setState({ show: true, ...data }, () => this.updateHash())
  }

  onCancel = () => {
    this.setState({ show: false, message_hash: '', selected_users: [] })
  }

  handleChange = ({ target: { name, value } }) => {
    this.setState({ [name]: value }, () => this.updateHash())
  }

  handleChangeMessage = message => {
    if (message === '<p><br></p>') message = ''
    this.setState({ message }, () => this.updateHash())
  }

  handleChangeUser = users => {
    this.setState({ selected_users: users.map(u => u.id) }, () => this.updateHash())
  }

  imageHandler = () => {
    const input = document.createElement('input')
    input.setAttribute('type', 'file')
    input.setAttribute('accept', 'image/*')
    input.click()

    input.onchange = async () => {
      const file = input.files[0]
      if (!file) return

      // Definisci le opzioni di compressione
      const maxSizeMB = 0.1 // Limite di dimensione in MB
      const options = {
        maxSizeMB: maxSizeMB,
        maxWidthOrHeight: 300, // Opzionale: riduci la dimensione massima in larghezza o altezza
        useWebWorker: true, // Usa il Web Worker per non bloccare il thread principale
      }

      try {
        let compressedFile = file

        // Comprimere l'immagine se la dimensione è troppo grande
        if (file.size > maxSizeMB * 1024 * 1024) {
          compressedFile = await imageCompression(file, options)
        }

        // Leggi il file compresso o il file originale come DataURL
        const reader = new FileReader()
        reader.readAsDataURL(compressedFile)

        reader.onload = () => {
          const base64 = reader.result
          const quill = this.quillRef.current.getEditor() // Usa il ref di React per ottenere l'istanza di Quill
          const range = quill.getSelection()

          // Aggiungi l'immagine come embed
          quill.insertEmbed(range.index, 'image', base64)

          // Aggiungi la classe 'img-fluid' usando jQuery o direttamente
          setTimeout(() => {
            const img = quill.container.querySelector(`img[src="${base64}"]`) // Trova l'immagine appena inserita
            if (img) {
              img.classList.add('img-fluid')
              img.style.maxHeight = '300px'
              img.style.width = 'auto'
            }
          }, 10) // Rit
        }
      } catch (error) {
        console.error('Error during image compression:', error)
      }
    }
  }

  modules = {
    toolbar: {
      container: [
        [{ header: [1, 2, 3, false] }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        ['blockquote', 'code-block'],
        [{ script: 'sub' }, { script: 'super' }],
        [{ indent: '-1' }, { indent: '+1' }],
        [{ direction: 'rtl' }],
        [{ color: [] }, { background: [] }],
        [{ align: [] }],
        ['link', 'image'],
        ['clean'],
      ],
      handlers: {
        image: this.imageHandler,
      },
    },
  }

  handleSave = async () => {
    let { id, selected_users, message, title } = this.state
    await this.props.onSave({ id, title, message, selected_users })
    this.onCancel()
  }

  isFormValid = () => {
    let { title, message, selected_users } = this.state
    return message !== '' && title !== '' && selected_users?.length > 0
  }

  render() {
    let { show, title, message, selected_users } = this.state
    return (
      <>
        <Modal show={show} backdrop="static" size="xl" keyboard={false} centered>
          <Modal.Header>
            <Modal.Title>
              <Trans i18nKey="components.messages.message_form.title">Crea messaggio</Trans>
            </Modal.Title>
          </Modal.Header>

          <Modal.Body className="d-flex flex-column">
            <div className="d-flex flex-row mb-3">
              <div className="d-flex flex-column flex-fill">
                <div className="mb-3">
                  <Form.Label>
                    <Trans i18nKey="components.users.users">Utenti</Trans>
                    <span className="text-danger"> *</span>
                  </Form.Label>
                  <div className="d-flex align-items-center text-muted">
                    <span>
                      <b>{selected_users.length}</b> <Trans i18nKey="components.users.selected">selezionati</Trans>
                    </span>
                    <Button className="ms-2" onClick={() => this.selectAgentsModalRef.current.show({ selected_users })}>
                      <i className="fas fa-plus fa-fw me-1"></i>
                      {selected_users.length > 0 ? (
                        <Trans i18nKey="components.users.edit_brand">Modifica</Trans>
                      ) : (
                        <Trans i18nKey="components.users.add_brand">Aggiungi</Trans>
                      )}
                    </Button>
                  </div>
                </div>

                {/* Sezione Titolo */}
                <Form.Group className="mb-3">
                  <Form.Label>
                    <Trans i18nKey="documents.title">Titolo</Trans>
                    <span className="text-danger"> *</span>
                  </Form.Label>
                  <Form.Control
                    name="title"
                    placeholder={t('documents.title', 'Titolo')}
                    value={title}
                    onChange={this.handleChange}
                  />
                </Form.Group>

                {/* Sezione Messaggio */}
                <Form.Group className="d-flex flex-column flex-grow-1">
                  <Form.Label>
                    <Trans i18nKey="admin.components.notification_rule.message">Messaggio</Trans>
                    <span className="text-danger"> *</span>
                  </Form.Label>

                  <style jsx="true" global="true">{`
                    .quill {
                      flex-grow: 1;
                      display: flex;
                      flex-direction: column;
                    }

                    .quill .ql-editor {
                      min-height: 100%;
                      height: 42vh !important;
                      overflow-y: auto !important;
                    }
                    .ql-editor strong {
                      font-weight: bold !important;
                    }
                  `}</style>

                  <ReactQuill
                    ref={this.quillRef}
                    theme="snow"
                    value={message}
                    onChange={this.handleChangeMessage}
                    modules={this.modules}
                    className="quill"
                  />
                </Form.Group>
              </div>
            </div>
          </Modal.Body>

          {/* Footer con i pulsanti */}
          <Modal.Footer>
            <Button variant="secondary" onClick={this.onCancel}>
              <Trans i18nKey="buttons.cancel">Annulla</Trans>
            </Button>
            <Button
              variant="primary"
              disabled={!this.isFormValid() || this.initialHash === this.state.message_hash}
              onClick={this.handleSave}>
              <Trans i18nKey="buttons.confirm">Conferma</Trans>
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Modale per selezionare gli utenti */}
        <SelectAgentsModal
          ref={this.selectAgentsModalRef}
          users={this.props.users}
          brands={this.props.brands}
          roles={this.props.roles}
          onChange={this.handleChangeUser}
          multiSelection={true}
        />
      </>
    )
  }
}
export default DocumentForm
